<template>
  <div class="all_clause">
    <header>
      <HeaderComponent :isShowBack="true" v-show="showHead" :title="title" class="heads"></HeaderComponent>
    </header>
    <div class="other">
      <div class="content">
        <!-- <h2>长龙航空旅客与机组携带危险物品操作规范</h2> -->
        <div class="con_body">
          <p>
            <strong>不允许旅客或机组成员将危险品作为随身携带、托运行李及手提行李运输，除非且满足以下条件</strong>
          </p>
          <table>
            <thead>
              <tr>
                <th>
                  <strong>序号</strong>
                </th>
                <th>
                  <strong>名称</strong>
                </th>
                <th>
                  <strong>托运行李</strong>
                </th>
                <th>
                  <strong>手提行李</strong>
                </th>
                <th>
                  <strong>随身携带</strong>
                </th>
                <th>
                  <strong>须经营人批准</strong>
                </th>
                <th>
                  <strong>通知机长</strong>
                </th>
                <th>
                  <strong>限制规定</strong>
                  <br />对需经航空公司批准方可携带的危险物品，请提示旅客提前向经营人联系以便评估安排
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>1</strong>
                </td>
                <td>
                  <strong>使人丧失行为能力的装置</strong>
                  <br />（如催泪瓦斯、胡椒喷雾器等）
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据国际民航组织《技术细则》要求，禁止旅客与机组携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>2</strong>
                </td>
                <td>
                  <strong>电击武器</strong>
                  <br />（如泰瑟枪）
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据国际民航组织《技术细则》要求，禁止旅客与机组携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>3</strong>
                </td>
                <td>
                  <strong>保险型公文箱、现金箱、现金袋</strong>
                  <br />（防盗抢设计，含锂电池和烟火装置）
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据国际民航组织《技术细则》要求，禁止旅客与机组携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>4</strong>
                </td>
                <td>
                  <strong>液氧装置</strong>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据国际民航组织《技术细则》要求，禁止旅客与机组携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>5</strong>
                </td>
                <td>
                  <strong>含锂电池电动平衡车</strong>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据公司政策要求，禁止旅客与机组携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>6</strong>
                </td>
                <td>
                  <strong>安全火柴或打火机</strong>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>中国民航局规定，禁止旅客携带或托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>7</strong>
                </td>
                <td>
                  <strong>医用氧气或空气瓶</strong>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>根据公司政策要求，禁止旅客与机组携带或托运。如旅客需使用飞行用氧，1、需提前48小时申请；2、需公司批准；3、必须由公司提供。</td>
              </tr>
              <tr>
                <td>
                  <strong>8</strong>
                </td>
                <td>
                  <strong>安全包装的弹药</strong>
                  <br />（仅限满足1.4s的弹药）
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>获得省级以上公安机关、警卫部门批准或豁免并经过航空公司许可。仅限本人自用，每人携带毛重不超过5kg（11磅）且不含爆炸性或燃烧性弹药。一名以上的旅客所携带的弹药不得合并成一个或数个包装件。</td>
              </tr>
              <tr>
                <td>
                  <strong>9</strong>
                </td>
                <td>
                  <strong>雪崩救援背包</strong>
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>每人允许携带一个。雪崩救援背包内装含有净重不超过200mg的1.4S项爆炸品的烟火引发装置或2.2项的压缩气体气瓶，包装方式必须保证不意外启动，背包内的空气袋必须安装减压阀。</td>
              </tr>
              <tr>
                <td>
                  <strong>10</strong>
                </td>
                <td>
                  <strong>充电宝</strong>
                  <br />（≤100Wh）
                </td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>单个做好保护以防短路，禁止托运。飞行过程中不得使用并处于关闭状态。(携带数量详见12项备用锂电池)</td>
              </tr>
              <tr>
                <td>
                  <strong>11</strong>
                </td>
                <td>
                  <strong>充电宝</strong>
                  <br />（＞100Wh但≤160Wh）
                </td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>单个做好保护以防短路，禁止托运。飞行过程中不得使用并处于关闭状态，不得携带超过2块。大于160Wh不允许携带。</td>
              </tr>
              <tr>
                <td>
                  <strong>12</strong>
                </td>
                <td>
                  <strong>备用锂电池</strong>
                  <br />（锂金属含量≤2g，锂离子电池≤100Wh）
                </td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>见限制规定</td>
                <td></td>
                <td>轻便电子设备（包括医疗装置）使用的备用锂电池，仅限在手提行李中携带，电池必须单个做好保护以防短路（放入零售包装或以其他方式将电极绝缘，如在暴露的电极上贴胶带，或将每个电池放入单独的塑料袋或者保护盒当中。）每人最多可携带20块备用锂电池（电动轮椅的备用电池、充电宝也计算在内）。仅在经营人批准下可超过限制的量。</td>
              </tr>
              <tr>
                <td>
                  <strong>13</strong>
                </td>
                <td>
                  <strong>备用锂电池</strong>
                  <br />（锂金属含量≤2g，锂离子电池≤100Wh）
                </td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>轻便电子装置（包括医疗装置）使用的瓦特小时大于100Wh但不大于160Wh的锂离子电池，或仅轻便电子装置使用的锂含量超过2g但不超过8g的锂金属电池。不得携带超过2块，仅限在手提行李中携带，电池必须单个做好保护以防短路。</td>
              </tr>
              <tr>
                <td>
                  <strong>14</strong>
                </td>
                <td>
                  <strong>锂电池供电的电子设备</strong>
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>轻便电子装置（包括医用装置）使用的瓦特小时大于100Wh但不大于160Wh的锂离子电池，锂含量超过2g但不超过8g的医用电子装置专用锂金属电池。若需托运，（1）必须采取措施防止意外启动并保护装置不受损坏（2）装置必须完全关闭（不在睡眠或者休眠模式）。</td>
              </tr>
              <tr>
                <td>
                  <strong>15</strong>
                </td>
                <td>
                  <strong>内含电池的便携式电子装置</strong>
                  <br />（锂金属含量≤2g，锂离子电池≤100Wh）
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>见限制规定</td>
                <td></td>
                <td>个人自用（包括医用装置）。如照相机、手机、笔记本电脑等，可以手提携带。若需托运，（1）必须采取措施防止意外启动并保护装置不受损坏（2）装置必须完全关闭（不在睡眠或者休眠模式）。每人最多可携带15个便携式电子设备（不计算电动轮椅），仅在经营人批准下可超过限制的量。</td>
              </tr>
              <tr>
                <td>
                  <strong>16</strong>
                </td>
                <td>
                  <strong>电子香烟</strong>
                </td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>必须单独保护以防意外启动。若为锂金属电池，锂金属含量不超过2g；若为锂离子电池，其额定能量不得超过100Wh。</td>
              </tr>
              <tr>
                <td rowspan="2">
                  <strong>17</strong>
                </td>
                <td>燃料电池</td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td rowspan="2">为便携式电子设备提供电力的燃料电池，以及备用燃料盒，但必须满足《DGR》2.3.5.9的要求。</td>
              </tr>
              <tr>
                <td>
                  <strong>备用燃料罐</strong>
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <strong>18</strong>
                </td>
                <td>
                  <strong>电动轮椅/助行器</strong>
                  <br />（防漏型湿电池驱动）
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>
                  （1）仅限老弱病残人员使用。
                  （2）防漏型电池不能存在游离、未被吸收的液体。
                  （3）电极绝缘处理，防意外启动，电池良好固定在设备上；轮椅或助行器必须固定在货舱内，防止移动或在其他行李、邮件或货物移动时受到损坏。
                  （4）如果电动轮椅专门设计成可由使用者拆下电池（如可折叠）的，则必须拆下电池；拆下的电池必须装在结实坚固的包装袋中，并且必须放在货舱中；电池必须采取保护措施，防止短路；必须将包装后的电池所放置的位置告知机长。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>19</strong>
                </td>
                <td>
                  <strong>电动轮椅/助行器</strong>
                  <br />（非防漏型湿电池驱动）
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>
                  （1）代步工具在装载、放置、固定以及卸机时都尽量保持直立方式；
                  （2）电池牢固安装在代步工具上；
                  （3）电池两级已做好防短路措施（例如将电池封装在电池盒内）；
                  （4）对轮椅或电池驱动的代步工具采取保护措施，防止由于行李、邮件或其他货物的移动受到损坏。
                  （5）如果代步工具不能在装载、防止、固定和卸机过程中保持直立状态，则必须卸下电池(卸下电池的轮椅或助行器可以作交运行李而不受限制),拆下的电池必须装入坚固、硬质包装内运输，且必须满足以下要求：
                  a.包装必须是严密不漏、能阻止电池液渗漏，并采取适当的固定方式，将包装固定在货板上或货舱内（不得使用货物或行李支撑）以防翻倒。
                  b.电池必须做好防短路工作，并直立固定在包装内，周围用相容的吸附材料填充，确保吸附材料能完全吸收电池泄漏的液体。
                  c.包装件必须标有“轮椅用湿电池（Battery,wet,withwheelchair）”或“代步工具用湿电池（Battery,wet,withmobility aid）”，并加贴腐蚀性物质标签和包装件方向性标签。
                  （6）必须通知机长安有电池的代步工具的位置或已包装电池的位置。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>20</strong>
                </td>
                <td>
                  <strong>装有锂电池电动轮椅/助行器</strong>
                </td>
                <td>见限制规定</td>
                <td>见限制规定</td>
                <td>见限制规定</td>
                <td>√</td>
                <td>√</td>
                <td>
                  （1）仅限老弱病残使用。
                  （2）锂电池必须是符合联合国UN38.3小节规定的每项实验的要求。
                  （3）如果锂电池可以拆下，电池必须拆下，并满足以下要求：
                  a.拆下的锂电池必须带入客舱，并应加以保护和做绝缘处理。
                  b.电池不得超过300Wh；如果轮椅运行需要2块电池的，则每块不得超过160Wh；
                  c.可携带一个不超过300Wh的备用电池，或两个均不超过160Wh的备用电池。
                  （4）经营人必须通知机长装有电池的助行器的位置，已卸下的电池和备用电池的位置；
                  （5）对于电池不可拆下的电动轮椅/助行器，进行托运，放入货舱，操作程序见DGR 2.3.2.4
                </td>
              </tr>
              <tr>
                <td>
                  <strong>21</strong>
                </td>
                <td>
                  <strong>装有锂电池的保安型设备/助行器</strong>
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>锂电池必须是符合联合国UN38.3小节规定的每项实验的要求。必须安装有效以防意外启动装置。</td>
              </tr>
              <tr>
                <td>
                  <strong>22</strong>
                </td>
                <td>
                  <strong>装有锂电池的行李（箱/袋）</strong>
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  （1）如果电池不可拆卸，且锂金属含量超过0.3g或锂离子电池容量超过2.7Wh，则禁止运输，若容量不超过限制则可运输。
                  （2）如果电池可作为交运行李，锂电池必须从行李上卸下并且将锂电池带入客舱，并做绝缘处理；
                </td>
              </tr>
              <tr>
                <td>
                  <strong>23</strong>
                </td>
                <td>
                  <strong>野营炉和燃料罐</strong>
                  <br />（不含任何燃料）
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>
                  经公司批准，需确保无燃料残留或用食用油等填充。
                  具体方法是，将容器排空至少1小时，然后打开盖子放置6小时以上，以使残余的易燃液体彻底挥发；或把食用油加入容器中，以提高残余液体的闪点，接着清空油箱。运输时，必须盖紧油箱的盖子，并用如纸巾等吸收性的材料包裹，放在聚乙烯袋或类似合适的包装内，包装的顶部必须密封或扎紧。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>24</strong>
                </td>
                <td>
                  <strong>水银气压计或温度计</strong>
                </td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td>√</td>
                <td>必须由政府气象局或类似官方机构的代表携带；每人只能携带一支水银气压计或水银温度计。必须将其放在外壳坚硬的包装内，且内有密封或坚固的防漏和防穿透材料制成的袋子，此种包装能防止水银从包装件中渗漏（不论该包装件的方向如何）。有关水银气压计或水银温度计的装载位置必须通知机长。</td>
              </tr>
              <tr>
                <td>
                  <strong>25</strong>
                </td>
                <td>
                  <strong>自动充气救生衣中小型气瓶</strong>
                  <br />（2.2项非易燃无毒气体）
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>安装在自动充气救生衣或救生背心中供充气用的二氧化碳或其他2.2项小型气瓶，每人携带最多两个该类气瓶，一个该类设备，另可携带两个备用气瓶。气罐不超过50ml。</td>
              </tr>
              <tr>
                <td>
                  <strong>26</strong>
                </td>
                <td>
                  <strong>机械假肢用小型气瓶</strong>
                  <br />（2.2项非易燃无毒气体）
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>用来操纵机械假肢运动的内装2.2项非易燃、无毒气体的小型气瓶。为保障旅途中的需要，还可携带自用的同样大小的备用气瓶。</td>
              </tr>
              <tr>
                <td>
                  <strong>27</strong>
                </td>
                <td>
                  <strong>固体二氧化碳（干冰）</strong>
                  <br />
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>
                  （1）为鲜活易腐食品保鲜用的干冰，每人≤2.5kg，包装要留有通气孔。
                  （2）如果放在交运行李中运输，则每个包装件必须标有：
                  a.“DRY ICE（干冰）”或“CARBON DIOXIDE, SOLID（固体二氧化碳）”字样；
                  b.干冰的净重或标明其净重小于等于2.5 kg 。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>28</strong>
                </td>
                <td>
                  <strong>启动后产生高热的物品</strong>
                  <br />（如潜水灯或焊接设备等）
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>启动后可产生高热和可能起火的电池动力设备，运输时必须卸下能产生热量的部件、电池或其他部件（如保险丝），将产生热量的部件或电池单独进行包装，防止运输中意外启动，对拆下的电池还应做绝缘处理。</td>
              </tr>
              <tr>
                <td>
                  <strong>29</strong>
                </td>
                <td>
                  <strong>医用临床含汞体温计</strong>
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>每位乘客允许携带一支小型医用含汞（水银）温度计，置于保护盒内并托运。</td>
              </tr>
              <tr>
                <td>
                  <strong>30</strong>
                </td>
                <td>
                  <strong>内燃发动机或燃料电池发动机</strong>
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>发动机及其燃料箱内无燃料、无电池或被清洗；</td>
              </tr>
              <tr>
                <td>
                  <strong>31</strong>
                </td>
                <td>
                  <strong>化学品监视设备</strong>
                  <br />（含放射性物质）
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>指国际禁止化学武器组织（OPCW）人员使用的化学监测仪（CAM）和/或快速报警装置（RAID-M）。含放射性活度不超过《技术细则》例外包装件的活度限制值，且包装牢固，不含锂电池。</td>
              </tr>
              <tr>
                <td>
                  <strong>32</strong>
                </td>
                <td>
                  <strong>非放射性药品或化妆用品以及第2.2项气溶胶</strong>
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>
                  每一单件物品的总净重数量不得超过0.5kg或0.5L，气溶胶释放阀必须由盖子或其他适当的手段保护，以防止意外释放内装物。
                  每位旅客携带或托运的总净数量不得超过2千克或2升。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>33</strong>
                </td>
                <td>
                  <strong>2.2项的气溶胶</strong>
                  <br />
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  每一单件物品的总净重数量不得超过0.5kg或0.5L，气溶胶释放阀必须由盖子或其他适当的手段保护，以防止意外释放内装物。
                  注：每位旅客携带或托运32、33、34项危险品的总净数量不得超过2千克或2升。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>34</strong>
                </td>
                <td>
                  <strong>化妆用品</strong>
                  <br />（如发胶、香水等）
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>
                  每一单件物品的总净重数量不得超过0.5kg或0.5L，气溶胶释放阀必须由盖子或其他适当的手段保护，以防止意外释放内装物。如需随身携带，每种化妆品限带一件，且其容器容积不得超过100ml。
                  注：每位旅客携带或托运32、33、34项危险品的总净数量不得超过2千克或2升。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>35</strong>
                </td>
                <td>
                  <strong>含有烃类气体的卷发器</strong>
                  <br />
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>卷发器的加热器上必须装有严密的安全盖，每名旅客或机组人员最多可带一个。禁止在航空器上使用。不得携带其卷发器的充气罐。</td>
              </tr>
              <tr>
                <td>
                  <strong>36</strong>
                </td>
                <td>
                  <strong>节能灯具</strong>
                  <br />
                </td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>个人或家庭使用的装在零售包装内的节能灯具。</td>
              </tr>
              <tr>
                <td>
                  <strong>37</strong>
                </td>
                <td>
                  <strong>酒精饮料</strong>
                  <br />
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  不得手提或随身携带（隔离区内购买的除外，但禁止在机上饮用）。托运时应符合下列规定：
                  (a)商业零售包装。
                  (b)酒精的体积百分含量小于或等于24%的，不受限制。
                  (c)酒精的体积百分含量大于24%但不超过70%的，每人交运数量不超过5L。
                  (d)酒精的体积百分含量大于70%的禁止携带。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>39</strong>
                </td>
                <td>
                  <strong>非感染性标本</strong>
                  <br />
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  （a）标本密封袋中游离易燃液体或硬质容器内的酒精不超过30ml；
                  （b）将标本先后放入塑料袋后热封，再放入另一个带有衬垫材料的塑料袋后热封，再将包装完的标本袋放入带有衬垫材料的坚固外包装。
                  （c）每个外包装所含易燃液体总量不超1升，标明“科研标本，不受限制，适用于特殊规定A180”。
                </td>
              </tr>
              <tr>
                <td>
                  <strong>40</strong>
                </td>
                <td>
                  <strong>含冷冻液氮的干式隔热包装</strong>
                  <br />
                </td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>隔热包装含有的液氮全部被多孔材料吸附，并且用于低温下运输非危险品。要求隔热包装能够确保其不会因放置的方向性而导致容器内压力增加和液氮溢出。</td>
              </tr>
              <tr>
                <td>
                  <strong>41</strong>
                </td>
                <td>
                  <strong>渗透装置</strong>
                  <br />
                </td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>仅限交运行李中，校准空气质量监测设备的渗透装置。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "@/components/header2";
import Common from "@/assets/js/common.js";
export default {
  data() {
    return {
      title: "长龙航空旅客与机组携带危险物品操作规范",
      showHead: true
    };
  },
  components: { HeaderComponent },
  created() {
    if (Common.getUrlQuery("fromapp")) {
      this.showHead = false;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/less/global.less";
/deep/.header_box h2 span {
    font-size: 14 * @base !important;
}
.all_clause {
  min-height: 100vh;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;

  header{
    position: sticky;
    top: 0;
    left: 0;
    border-bottom: 1px solid #f0f0f0;
  }
}
.padds {
  padding-top: 70 * @base;
}
.other {
  .content {
    padding: 0 20px;
    h2 {
      text-align: center;
      border-bottom: 1px dashed #ddd;
      font-size: 16px;
      padding: 15px 0;
      color: #333;
    }
    .con_body {
      padding: 20px 0;
      line-height: 26px;
      width: 100%;
      overflow-x: scroll;
      p {
        text-indent: 2em;
        margin-bottom: 10px;
        img {
          display: block;
          margin: 0 auto;
        }
      }
      table {
        border-collapse: collapse;
        min-width: 783px;
      }
      th,
      td {
        padding: 5px;
        border: 1px solid #eee;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/inforule/dangerRule.vue